import auth from '../../services/auth'

export default {

  data() {
    return {
      taxIdNumber: undefined,

      formState: 'NEW',
      loading: false,
      TFACode: undefined,
      origemTelas: undefined,
      origin: undefined
    }
  },

  computed: {
    type() {
      return this.$route.params.type;
    }
  },

  created(){
    this.taxIdNumber = this.$route.query.taxIdNumber;
  },

  methods: {
    // verificaOrigemTelas(origemTelas) {
    //   this.origemTelas = this.$route.params.type;
    //   if(origemTelas == 'desbloqueioConta') {
    //     return origin = 'RESET_PASSWORD';
    //   } else {
    //     if (origemTelas == 'reset') {
    //       return origin = 'RESET_PASSWORD';
    //     } else {
    //       return origin = 'LOGIN'
    //     }
    //   }
    // },
    requestAgain() {
      if (this.$route.params.type == 'desbloqueioConta' || this.$route.params.type == 'reset') {
        origin = 'RESET_PASSWORD';
      } else {
        if (this.$route.params.type == 'login') {
          origin = 'LOGIN';
        };
      };
      
      const hash = auth.getHash();
      const isAccountUnlock = hash.includes('escolher-canal/desbloqueioConta');
      const isResetPassword = hash.includes('escolher-canal/reset');

      const redirectPage = isResetPassword || isAccountUnlock ? 'password-set' : 'login';
      const redirectParams = isResetPassword || isAccountUnlock ? 'desbloqueioConta' : 'reset';

      // const origin = isResetPassword ? 'RESET_PASSWORD' : "LOGIN";

      this.formState = 'NEW';
      this.$validator.validateAll().then(success => {
        let taxIdNumber = auth.getTaxIdNumber();
        auth.tokenGenerateResend(taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), origin);
        console.log('ok');
      });
    },

    doRequest() {
      if (this.$route.params.type == 'desbloqueioConta' || this.$route.params.type == 'reset') {
        origin = 'RESET_PASSWORD';
      } else {
        if (this.$route.params.type == 'login') {
          origin = 'LOGIN';
        };
      };

      const hash = auth.getHash();
      const isAccountUnlock = hash.includes('escolher-canal/desbloqueioConta');
      const isResetPassword = hash.includes('escolher-canal/reset');

      const redirectPage = isResetPassword || isAccountUnlock ? 'password-set' : 'login';
      const redirectParams = isResetPassword || isAccountUnlock ? 'desbloqueioConta' : 'reset';

      // const origin = isResetPassword ? 'RESET_PASSWORD' : "LOGIN";

      this.formState = 'NEW';
      this.$validator.validateAll()
        .then(success => {
          let taxIdNumber = auth.getTaxIdNumber();
          auth.twoFactorAuthentication(taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), this.TFACode, origin).then(data => {
            if(data.status.code === 0) {
              auth.saveToken(this.TFACode);
              auth.saveMoveMaisId(data.movemaisId);
              this.$router.push({name: redirectPage, params:{type: redirectParams}});
            }
          })
          .catch(err => {
            this.formState = 'ERROR';
                this.errorMessage = err.data.status.message;
          });
        });
        
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/2fa.js